<template>
  <div class="container" @keyup.escape="selected = undefined">
    <b-col cols="12">
      <p>
        <strong>INSTRUCCIONES:</strong>
      </p>
      <p v-html="data.instrucciones"></p>
    </b-col>
    <b-col cols="12" style="text-align: right;">
      <button v-b-modal.modal-vista-previa-crucigrama class="btn btn-primary">Vista previa PDF</button>
    </b-col>
    <div class="table-container" style="display:none;" v-show="true">
      <!--<div class="mensaje" v-if="mensaje !== undefined">
        <div class="content">{{mensaje}}</div>
        <button @click="mensaje = undefined" class="btn btn-primary">OK</button>
      </div>-->
      <table>
        <tr v-for="(row, y) in matrixArry" :key="y">
          <td
            v-for="(cell, x) in row"
            :key="x"
            :class="{empty: cell.empty, start: !!cell.start, selected: cell.words.includes(selected)}"
            @click="selectWord(cell.start)"
          >
            <label v-if="!!cell.start">{{cell.start}}</label>
            <span v-if="!mostrarRespuestas">{{cell.words.some(i => completed[i]) ? cell.letter : ' '}}</span>
            <span v-if="mostrarRespuestas">{{cell.letter}}</span>
          </td>
        </tr>
      </table>
      <div v-if="selected !== undefined" style="text-align: center;">
        <p class="pista" v-if="pista" style="margin-top: 20px;" v-html="pista"></p>
        <b-form-input
          v-model="answer"
          ref="input"
          @keyup.enter="corregir"
          style="margin-bottom:10px;"
        ></b-form-input>
        <span class="incorrecta-palabra" v-if="incorrecta">Palabra incorrecta</span>
        <!--<input v-model="answer" ref="input" @keyup.enter="corregir" />-->
        <br />
        <button @click="corregir" class="btn btn-primary" style="margin: 10px 5px;">Colocar Palabra</button>
        <button @click="solucion" class="btn btn-danger" style="margin: 10px 5px;">Mostrar Pista</button>
      </div>
      <hr />
      <b-col cols="12" class="text-center">
      <span>Mostrar Respuestas</span>
      <c-switch
        color="success"
        label
        variant="pill"
        size="lg"
        @change="toggleRespuestasCrucigrama($event)"
      />
      </b-col>
      <!--<button class="btn btn-block btn-primary" @click="finalizar">Finalizar</button>-->
      <b-col cols="12">
        <b-button
          style="float: right; margin: 10px"
          variant="primary"
          @click="finalizar"
        >Verificar Resultados</b-button>
      </b-col>
    </div>
    <h3 v-show="false">Cargando....</h3>
    <modal-vista-previa-crucigrama :contenido="data"></modal-vista-previa-crucigrama>
  </div>
</template>
<script>
// Objeto default para celdas vacías de la grilla
const empty = {
  start: false,
  letter: "",
  words: [],
  empty: true
};

import { Switch as cSwitch } from "@coreui/vue";
import ModalVistaPreviaCrucigrama from "@/components/ModalVistaPreviaCrucigrama";

export default {
  name: "pre-crucigrama",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          index: null,
          tag: "Crucigrama",
          palabras: [],
          matrix: [],
          instrucciones: "",
          data: "",
          horizontal: null,
          vertical: null
        };
      }
    }
  },
  components: {
    cSwitch,
    ModalVistaPreviaCrucigrama,
  },
  data() {
    return {
      index: null,
      // Arreglo de booleanos indicando si una palabra fue completada
      completed: Array().fill(false),
      // Entero indicando la palabra que fue seleccionada para completar
      selected: undefined,
      // String donde se guarda lo que ingresa el usuario
      answer: "",
      // Cantidad de veces que se solicitó una pista
      penalties: 0,
      // Temporizador en segundos desde el comienzo de la partida. Comienza en 5 minutos.
      timer: 60 * 5,
      // La tabla que será armada al inicio, conteniendo todas las celdas
      matrixArry: [],
      // Mensaje final a mostrar
      mensaje: undefined,
      // Palabras agregadas
      palabrasArry: [],
      incorrecta: false,
      mostrarRespuestas: false
    };
  },
  created() {
    // Creación de la tabla que contiene las celdas.
    /*const width = this.data.palabras.reduce(
      (max, cur) =>
        Math.max(
          max,
          cur.pos[0] + (cur.sentido === 0 ? cur.palabra.length : 1)
        ),
      0
    );
    const height = this.data.palabras.reduce(
      (max, cur) =>
        Math.max(
          max,
          cur.pos[1] + (cur.sentido === 1 ? cur.palabra.length : 1)
        ),
      0
    );*/
    const width = this.data.horizontal;
    const height = this.data.vertical;
    let matrix = Array(height)
      .fill(0)
      .map(() =>
        Array(width)
          .fill(null)
          .map(() => empty)
      );
    this.data.palabras.forEach((palabra, index) => {
      const [x, y] = palabra.pos;
      palabra.palabra.split("").forEach((l, i) => {
        let cell =
          matrix[y + (palabra.sentido ? i : 0)][x + (palabra.sentido ? 0 : i)];
        if (cell === empty) {
          cell = matrix[y + (palabra.sentido ? i : 0)][
            x + (palabra.sentido ? 0 : i)
          ] = { words: [] };
        }
        cell.empty = false;
        cell.words.push(index);
        if (i === 0) {
          cell.start = index + 1;
        }
        cell.letter = l;
      });
    });
    console.log(matrix);
    this.matrixArry = matrix;
  },
  computed: {
    // Contiene la pista de la palabra seleccionada
    pista() {
      if (this.selected === undefined) return undefined;
      return `<strong>${
        this.data.palabras[this.selected].sentido ? "Vertical" : "Horizontal"
      } ${this.selected + 1}</strong>: ${
        this.data.palabras[this.selected].pista
      }`;
    }
  },
  methods: {
    selectWord(index) {
      if (index > 0) {
        this.selected = index - 1;
        this.answer = "";
        setTimeout(() => this.$refs.input.focus(), 50);
      }
    },
    // Se fija si la palabra ingresada es correcta y de ser así, modifica el arreglo de palabras completas
    corregir() {
      const solucion = this.data.palabras[this.selected].palabra;
      const answer = this.answer.toLowerCase();
      if (answer === solucion) {
        this.completed[this.selected] = true;
        this.selected = undefined;
        console.log("correcta");
        this.incorrecta = false;
      } else {
        this.incorrecta = true;
        setTimeout(() => {
          this.incorrecta = false;
        }, 2000);
        console.log("NO correcta");
      }
    },
    // Agrega una letra correcta más a la respuesta actual
    solucion() {
      const solucion = this.data.palabras[this.selected].palabra;
      const answer = this.answer.toLowerCase();
      if (answer === solucion) {
        return;
      }
      if (answer !== solucion.slice(0, answer.length)) {
        this.penalties++;
        this.answer = "";
      }
      this.answer = solucion.slice(0, this.answer.length + 1);
      this.penalties++;
    },
    // Calcula el puntaje final del jugador en base a las respuestas correctas y las penalidades por pistas
    finalizar() {
      console.log(this.completed);
      if (this.completed.length > 0) {
        const total = this.completed.reduce(
          (total, current, i) => total + this.data.palabras[i].palabra.length,
          0
        );
        const completo = this.completed.reduce(
          (total, current, i) =>
            current ? total + this.data.palabras[i].palabra.length : total,
          0
        );
        const tempScore = Math.ceil((100 * completo) / total);
        const finalScore = Math.max(tempScore - this.penalties, 0);
        if (tempScore < 100) {
          this.penalties++;
        }
        this.mensaje = `Tu porcentaje de calificación en esta actividad es del ${finalScore}%.`;
        this.$swal({
          type: "success",
          title: "¡EN HORA BUENA!",
          text: `${this.mensaje}`,
          showCancelButton: false,
          confirmButtonColor: "#285c4d",
          confirmButtonText: "Aceptar"
        }).then(result => {
          if (result.value) {
          }
        });
      } else {
        this.$root.triggerWarnMgs("Completa el crucigrama", "");
      }
    },
    toggleRespuestasCrucigrama(e) {
      if(e){
        this.mostrarRespuestas = true;
      } else {
        this.mostrarRespuestas = false;
      }      
    },
  }
};
</script>
<style scoped>
.container {
  margin-top: 3vh;
}
.table-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
table {
  border-collapse: collapse;
  font-size: 18px;
  margin: 0 auto;
}
td {
  width: 36px;
  height: 36px;
  border: 1px solid black;
  text-align: center;
  position: relative;
  text-transform: uppercase;
  font-family: arial;
}
td.empty {
  background: #eceff1;
}
td.selected {
  background: lightblue;
}
td.start {
  cursor: pointer;
}
td.start label {
  position: absolute;
  top: 0;
  left: 2px;
  text-align: left;
  font-size: 10px;
}
td.start:hover {
  background: #eee;
}
td.start.selected:hover {
  background: #ddf;
}
.mensaje {
  position: absolute;
  color: white;
  left: 25vw;
  text-align: center;
  border-radius: 8px;
  padding: 10px;
  width: 50vw;
  z-index: 1000;
  background: rgba(0, 0, 255, 0.9);
}
.mensaje button {
  margin-top: 10px;
}
.list-group-item {
  border: none !important;
}
.incorrecta-palabra {
  color: red;
}
</style>